import api_agents from '../api/agents'
import api_base from '../api/api'


// initial state
const state = {
  role: undefined,
  docs: [],
  list_state: 'loading',
};

// getters
// noinspection JSUnusedGlobalSymbols
const getters = {
  api: (state) => {
    if (state.role === 'agent') return api_agents;
    if (state.role === 'user') return api_base;
    return {};
  },
  allDocs: state => {
    return _.orderBy(state.docs, 'attributes.created_at')
  },
};

// actions
// noinspection JSUnusedGlobalSymbols
const actions = {
  getDocs({dispatch, commit, getters}, payload) {
    console.log('ACTION - getDocs :', payload);
    commit('setListState', 'loading');
    return getters.api.getDocs(payload, data => {
      commit('setDocs', data.data);
      commit('setListState', 'stored');
    })
  },

  addDoc({dispatch, commit, getters}, payload) {
    console.log('ACTION - addDoc :', payload);
    return getters.api.createDoc(payload, data => {
      commit('addDoc', data.data);
    });
  },

  deleteDoc({dispatch, commit, getters}, payload) {
    console.log('ACTION - deleteDoc :', payload);
    return getters.api.destroyDoc(payload, data => {
      commit('removeDoc', data.data);
    });
  },

};

// mutations
// noinspection JSUnusedGlobalSymbols
const mutations = {
  setListRole(state, role){
    state.role = role;
  },

  setDocs (state, items) {
    state.docs = items;
  },

  setListState (state, list_status) {
    state.list_state = list_status;
  },

  addDoc (state, item) {
    console.log('MUTATION - addDoc:', state, item);
    let i = _.findIndex(state.docs, ['id', item.id]);
    if (i === -1) state.docs.push(item);
  },

  removeDoc (state, item) {
    console.log('MUTATION - removeDoc:', item);
    let i = _.findIndex(state.docs, {id: item.id});
    if (i > -1) {
      console.log('Элемент найден!', i, item);
      state.docs.splice(i, 1);
    } else {
      console.log('Элемент не найден', item);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
